// extracted by mini-css-extract-plugin
export default {"picker":"Page_AddModule_picker__crSRT","inner":"Page_AddModule_inner__pw0YZ","title":"Page_AddModule_title__dMu9o","description":"Page_AddModule_description__M8Gor"};